module.exports = __webpack_public_path__ + "static/media/sacramento_team.dbde6baf.jpg";